import type { ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const getIsChargeCompatibleWithPayments:
UseCase<ChargerRepository, 'getIsChargeCompatibleWithPayments'> = repository => {
  return async charger => {
    return await repository.getIsChargeCompatibleWithPayments(charger)
  }
}
